import { Link } from "react-router-dom";
import { films, specialList } from "@/lib/films";

const features = [
  {
    icon: "ri-file-text-line",
    title: "完整剧情梳理",
    text: "不做一句话简介，把人物关系与前因后果讲明白。",
  },
  {
    icon: "ri-user-star-line",
    title: "演员与幕后资料",
    text: "导演、主演、类型与地区信息逐条核对，方便检索。",
  },
  {
    icon: "ri-chat-quote-line",
    title: "有观点的影评",
    text: "邀请影评人与研究者撰稿，保留分歧，不写公关稿。",
  },
];

export default function SiteIntro() {
  const reviewCount = films.reduce((total, film) => total + film.reviews.length, 0);
  const regionCount = new Set(films.map((film) => film.region)).size;

  const stats = [
    { value: films.length, label: "影视条目" },
    { value: reviewCount, label: "影评文章" },
    { value: specialList.length, label: "专题策划" },
    { value: regionCount, label: "覆盖地区" },
  ];

  return (
    <section className="mt-16 bg-background-100 py-12 md:mt-20 md:py-16">
      <div className="container-portal grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-14">
        <div>
          <div className="flex items-center gap-2">
            <span className="h-[3px] w-6 rounded-full bg-accent-500" />
            <span className="label-caps text-[11px] text-accent-700">About us</span>
          </div>
          <h2 className="mt-3 text-xl font-bold tracking-tight text-foreground-950 md:text-[26px]">
            把故事讲清楚，是我们的底线
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-700">
            人兽影视网是一个以内容为核心的影视门户。我们把每天新增的影视信息整理成可检索、可比较的条目：剧情梗概、演员表、上映信息与影评观点都放在同一页里，减少来回跳转。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            我们不提供播放与下载，也不做资源聚合。这里只讨论作品本身，以及它为什么值得被看见。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
          >
            了解网站定位与联系方式
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${feature.icon} text-lg`} />
                </span>
                <h3 className="mt-3 text-sm font-semibold text-foreground-950">{feature.title}</h3>
                <p className="mt-1.5 text-xs leading-5 text-foreground-600">{feature.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-4 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="bg-background-50 px-4 py-4">
                <p className="font-label text-2xl leading-none text-primary-700">{stat.value}</p>
                <p className="mt-1.5 text-[11px] text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}